import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "VolumeUp"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.37 6.05999L19.2225 7.02749C21.6618 9.9169 21.5685 14.1702 19.005 16.95L20.1075 18C23.1859 14.6642 23.2985 9.55815 20.37 6.08999V6.05999ZM13.5 22.5C13.2996 22.4992 13.1078 22.4181 12.9675 22.275L7.2525 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V8.24999C1.5 7.83578 1.83579 7.49999 2.25 7.49999H7.2525L12.9675 1.72499C13.26 1.4342 13.7325 1.4342 14.025 1.72499C14.1663 1.86346 14.2472 2.05216 14.25 2.24999V21.75C14.25 22.1642 13.9142 22.5 13.5 22.5ZM16.1849 8.99999C17.6481 10.735 17.5902 13.2881 16.0499 14.955L17.1524 15.975C19.2054 13.7501 19.2794 10.3444 17.3249 8.03249L16.1849 8.99999ZM7.56 15H3V8.99999H7.56C7.76043 8.99916 7.9522 8.91813 8.0925 8.77499L12.75 4.07249V19.9275L8.0925 15.225C7.9522 15.0818 7.76043 15.0008 7.56 15Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/VolumeUp.vue"]]);
